import { MenuIdProjects } from '@jira/navigation-apps__constants/src/MenuIdProjects.tsx';
import { SidebarIdBoardSettings } from '@jira/navigation-apps__constants/src/SidebarIdBoardSettings.tsx';
import { getBoardDetailsResource } from '@jira/router-resources__classic-projects/src/getBoardDetailsResource.tsx';
import { getEditModelResource } from '@jira/router-resources__classic-projects/src/getEditModelResource.tsx';
import {
	getRapidboardResources,
	getRapidBoardDataResource,
	shouldLoadUIFBoardResources,
} from '@jira/router-resources__classic-projects/src/getRapidboardResources.tsx';
import { genericProjectLayout } from '@jira/platform__layouts-generic-project-layout/src/index.tsx';
import { forgeProjectModuleResource } from '@jira/navigation-apps__resources/src/controllers/forge/index.tsx';
import { staticProjectSidebarConnectAddonsNavigationResource } from '@jira/navigation-apps__resources/src/controllers/sidebar/static-project-sidebar-connect-addons/index.tsx';
import { staticProjectSidebarNavigationResource } from '@jira/navigation-apps__resources/src/controllers/sidebar/static-project-sidebar/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import {
	getNavigationResources,
	getUserBoardNavigationResources,
} from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { projectContextResource } from '@jira/router-resources__project-context/src/projectContextResource.tsx';
import { incidentExperimentTraitResource } from '@jira/router-resources__software-incidents/src/incidentExperimentTraitResource.tsx';
import { uifBoardResource } from '@jira/router-resources__uif-board/src/uifBoardResource.tsx';
import { resourceWithCondition } from '@jira/router-resources__utils/src/resourceWithCondition.tsx';
import { userBoardSettingsRoute } from '@jira/router-routes__user-board-routes/src/userBoardSettingsRoute.tsx';
import { ClassicBoardSkeleton } from '@jira/platform__skeletons/src/ui/classic-board/ClassicBoardSkeleton.tsx';
import {
	boardSettingsPageEntryPoint,
	GSNBoardSettingsPageEntryPoint,
} from '@jira/router-routes__software-classic-board-settings-entries/src/ui/page-entry-point/index.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import type { Route } from '@atlassian/react-resource-router';

/**
 * Jira Software user-located board-settings SPA route.
 *
 * NOTE: This component is mostly a copy of .../router-routes/software/classic/board-settings/entries/src/classicSoftwareBoardSettingsRouteEntry.tsx
 */
export const userBoardSettingsRouteEntry: Route = createEntry(userBoardSettingsRoute, () => ({
	group: 'classic-software',
	ufoName: 'classic-board',
	skeleton: ClassicBoardSkeleton,
	entryPoint: () =>
		fg('navx-global-side-nav') ? GSNBoardSettingsPageEntryPoint : boardSettingsPageEntryPoint,

	navigation: {
		menuId: MenuIdProjects,
		sidebarId: SidebarIdBoardSettings,
	},

	layout: genericProjectLayout,

	// This list is based on the resources needed by ./userBoardRouteEntry.tsx
	resources: [
		...getNavigationResources(),
		// these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them if needed
		// A guide to check & cleanup: https://hello.atlassian.net/wiki/x/Q8XybwE
		incidentExperimentTraitResource,
		// eslint-disable-next-line jira/router/no-project-context-resource
		projectContextResource,
		forgeProjectModuleResource,
		staticProjectSidebarNavigationResource,
		staticProjectSidebarConnectAddonsNavigationResource,
		// end of resources expanded from getNavigationSidebarProjectResource
		...getRapidboardResources(),
		getRapidBoardDataResource(),
		...getUserBoardNavigationResources(),
		resourceWithCondition(shouldLoadUIFBoardResources, uifBoardResource),
		getEditModelResource(),
		getBoardDetailsResource(),
	],

	bifrost: {
		bifrostGroup: 'shell-only',
	},
}));
